/*
,------.,--.,------. ,------.,-----.    ,---.   ,---.  ,------.
|  .---'|  ||  .--. '|  .---'|  |) /_  /  O  \ '   .-' |  .---'
|  `--, |  ||  '--'.'|  `--, |  .-.  \|  .-.  |`.  `-. |  `--,
|  |`   |  ||  |\  \ |  `---.|  '--' /|  | |  |.-'    ||  `---.
`--'    `--'`--' '--'`------'`------' `--' `--'`-----' `------'

FIREBASE RESPONSIBLE FOR THE USER THE FIREBASE SDK, MAINLY LISTEN RO THE
SERVER DATA CHANGE AND SEND THE NEW DATA TO THE LOCAL DB; IT ALSO WRITE THE
DATA TO THE SERVER ON ONLINE MODE (NOTE: ON ONLINE MODE, THE WRITE FILE WILL NOT
    BE SEND THE OFFLINE DB FOR FUTURE RETRY)
*/

/// ///////////////////////////////////////////////////////////////////////////////////////

/*
,--.  ,--.,------.,--.   ,------. ,------.,------.
|  '--'  ||  .---'|  |   |  .--. '|  .---'|  .--. '
|  .--.  ||  `--, |  |   |  '--' ||  `--, |  '--'.'
|  |  |  ||  `---.|  '--.|  | --' |  `---.|  |\  \
`--'  `--'`------'`-----'`--'     `------'`--' '--'
 ,---. ,--------.,------. ,--.,--.  ,--. ,----.
'   .-''--.  .--'|  .--. '|  ||  ,'.|  |'  .-./
`.  `-.   |  |   |  '--'.'|  ||  |' '  ||  | .---.
.-'    |  |  |   |  |\  \ |  ||  | `   |'  '--'  |
`-----'   `--'   `--' '--'`--'`--'  `--' `------'
*/

/*
 ,---.  ,------.,--------.,--. ,--.,------.
'   .-' |  .---''--.  .--'|  | |  ||  .--. '
`.  `-. |  `--,    |  |   |  | |  ||  '--' |
.-'    ||  `---.   |  |   '  '-'  '|  | --'
`-----' `------'   `--'    `-----' `--'
*/

/* eslint no-return-await: 0 */

import is from 'is_js'
import firebase from 'firebase/app'
// import 'firebase/messaging'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import settings from './settings'

const CONSOLE_TAG_GREEN = 'color: white; background-color: #2ecc71; height: 16px; border-radius: 8px; display: inline-block; padding-left: 4px; padding-right: 4px;'
const CONSOLE_TAG_ORANGE = 'color: white; background-color: #f39c12; height: 16px; border-radius: 8px; display: inline-block; padding-left: 4px; padding-right: 4px;'
const CONSOLE_TAG_RED = 'color: white; background-color: #e74c3c; height: 16px; border-radius: 8px; display: inline-block; padding-left: 4px; padding-right: 4px;'
const CONSOLE_TAG_BLUE = 'color: white; background-color: #3498db; height: 16px; border-radius: 8px; display: inline-block; padding-left: 4px; padding-right: 4px;'
// const AUTHOR_ICON = 'display: block; height: 100px; width: 100px; background: url(https://i.postimg.cc/qtv4ypzj/photo-2019-04-02-15-25-43.jpg) no-repeat; font-size:150px;'

// !!! IMPORTANT TO SET TO TRUE BEFORE DEPLOY PRODUCTION VERSION !!!
const IS_PRODUCTION = settings.production
if (IS_PRODUCTION) {
  console.log('%c !!! DO NOT DO DEVELOPMENT OR TESTING UNDER PRODUCTION MODE !!! ', CONSOLE_TAG_RED)
}
const dbSpace = settings.databaseSpace
console.log('%c Setting ', CONSOLE_TAG_ORANGE, `Current Database Target => ${dbSpace}`)

// Firebase setup (!!! DO NOT MAKE IT PUBLIC BEFORE DEPLOY OF SECURITY RULE OF STORAGE AND FIRESTORE !!!)
firebase.initializeApp({
  apiKey: 'AIzaSyAinhkuN3YRa1DfbtIXXOr1R3sf2rLH2nM',
  authDomain: 'am-center-1544478618166.firebaseapp.com',
  databaseURL: 'https://am-center-1544478618166.firebaseio.com',
  projectId: 'am-center-1544478618166',
  storageBucket: 'am-center-1544478618166.appspot.com',
  messagingSenderId: '34603952338'
})

// create firebase interface instance
export var auth = firebase.auth() // User sign in/up
var db = firebase.firestore() // Database
export var functions = firebase.functions() // Cloud function api caller
var storage = IS_PRODUCTION ? firebase.app().storage('gs://am-center-x-prod') : firebase.app().storage('gs://am-center-x-dev')

// firestore reference
const DB_ROOT = db.collection('ROOT').doc(`${IS_PRODUCTION ? 'prodDB' : dbSpace}`)
const PROJECT_LIST_REF = DB_ROOT.collection('projects')
const FOLDER_LIST_REF = DB_ROOT.collection('folders')
const ITEM_LIST_REF = DB_ROOT.collection('items')
const USER_LIST_REF = db.collection('users') // only one user database (no dev or prod mode)
const FORM_TEMPLATE_LIST_REF = DB_ROOT.collection('formTemplates')
const FORM_QUESTION_LIST_REF = DB_ROOT.collection('formQuestions')

// runtime states
var states = {
  // real time listener for firestore data (run this to unlink the listen)

}

var authStateListener = null // if null, online init not finished yet OR re-init is required

var listeners = {

  currentUser: () => { console.warn('Link to user before unlink it.') },

  currentProject: () => { /* console.warn('Link to project before unlink it.') */ },
  currentFolders: () => { /* console.warn('Link to project before unlink it.') */ },
  currentItems: () => { /* console.warn('Link to project before unlink it.') */ },

  projects: () => { console.warn('Link to project list before unlink it.') },
  formTemplates: () => { console.warn('Link to form template list before unlink it.') },
  formQuestions: () => { console.warn('Link to form question list before unlink it.') },
  users: () => { console.warn('Link to users before unlink') }
}

/// ///////////////////////////////////////////////////////////////////////////////////////
/*
  ,---.  ,------. ,--.
 /  O  \ |  .--. '|  | ,---.
|  .-.  ||  '--' ||  |(  .-'
|  | |  ||  | --' |  |.-'  `)
`--' `--'`--'     `--'`----'
*/

// APIs used to access this module
export default {
  recordSignIn: recordSignIn,
  listenToUser: listenToUser,
  verifyReCaptcha: verifyReCaptcha,
  createTempUser: createTempUser,
  createNewAuthUser: createNewAuthUser,
  onlineInit: onlineInit,
  authSignIn: authSignIn,
  authSignOut: authSignOut,
  resetPassword: resetPassword,
  connect: connect,
  switchProjectOnline: switchProjectOnline,
  addProject: addProject,
  getRandomId: getRandomId,
  setFolderOnline: setFolderOnline,
  // uploadOfflineFolders: uploadOfflineFolders,
  setItemOnline: setItemOnline,
  uploadImageOnline: uploadImageOnline,
  sendInvitationEmail: sendInvitationEmail,
  changeUserStatus: changeUserStatus,
  changeUserScope: changeUserScope,
  changeProjectSetting: changeProjectSetting,
  uploadExportedFile: uploadExportedFile
}
async function verifyReCaptcha (token) {
  if (!IS_PRODUCTION) {
    return true
  }
  const verifyAPI = functions.httpsCallable('verifyReCaptcha')
  try {
    let verifyResult = await verifyAPI({ text: JSON.stringify({ token: token }) })
    console.groupCollapsed('%c User ', CONSOLE_TAG_BLUE, 'Verify reCAPTCHA')
    console.log(verifyResult)
    console.groupEnd()
    return verifyResult.data.pass
  } catch (err) {
    console.warn(err)
    return false
  }
  // console.log('reCAPTCHA process done =>', verifyResult)
}
async function createTempUser (signUpRequest) {
  if (signUpRequest.type === 'EMAIL') {
    // verify if request meet requirements
    if (!is.email(signUpRequest.email)) {
      return {
        success: false,
        error: 'Invalid Email Address'
      }
    }
    if (signUpRequest.password.length < 6) {
      return {
        success: false,
        error: 'Password Too Weak'
      }
    }
    if (!signUpRequest.name.last || !signUpRequest.name.first) {
      return {
        success: false,
        error: 'Missing Information'
      }
    }
    // test invitation code
    // console.log(signUpRequest)
    try {
      console.log('%c User ', CONSOLE_TAG_BLUE, 'Create Temp User')
      let invitationDoc = await db.collection('signUpInvitation').doc(signUpRequest.invitationCode).get()
      if (!invitationDoc.exists) {
        // console.log('invitation code not found =>', signUpRequest.invitationCode)
        return {
          success: false,
          error: 'Invalid Invitation Code'
        }
      }
      let invitation = invitationDoc.data()
      // console.log(invitation)
      if (invitation.expiredOn < Date.now()) {
        console.log('%c User ', CONSOLE_TAG_RED, 'Invitation Expired')
        return {
          success: false,
          error: 'Invitation Expired'
        }
      }
      if (invitation.used) {
        console.log('%c User ', CONSOLE_TAG_RED, 'Invitation Expired')
        return {
          success: false,
          error: 'Invitation Expired'
        }
      }
      if (invitation.email !== signUpRequest.email) {
        console.log('%c User ', CONSOLE_TAG_RED, 'Email mismatch')
        return {
          success: false,
          error: 'Invalid Invitation Code'
        }
      }
    } catch (err) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'No Network Connection')
      console.log(err)
      console.groupEnd()
      return {
        success: false,
        error: 'Network error'
      }
    }
    db.collection('signUpInvitation').doc(signUpRequest.invitationCode).update({ used: true })
    // test duplicate on database
    let queryUsers = await USER_LIST_REF.where('email', '==', signUpRequest.email).get()
    if (!queryUsers.empty) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'User Existed')
      console.log(signUpRequest.email)
      console.groupEnd()
      return {
        success: false,
        error: 'User Already Exists'
      }
    }
    // add temp user info
    let currentUser = {
      id: window.btoa(signUpRequest.email).replace(/\//g, ''),
      email: signUpRequest.email,
      name: signUpRequest.name,
      userScope: 3,
      createOn: Date.now(),
      status: 'PENDING'
    }
    try {
      await USER_LIST_REF.doc(currentUser.id).set(currentUser)
      return {
        success: true,
        error: ''
      }
    } catch (err) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'User Create Failed')
      console.log(err)
      console.groupEnd()
      return {
        success: false,
        error: 'Cannot Create User [code=1]'
      }
    }
  } else {
    console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Unknown Sign Up Method')
    console.log(signUpRequest.type)
    console.groupEnd()
    return {
      success: false,
      error: `Unknown Sign Method => ${signUpRequest.type}`
    }
  }
}

async function createNewAuthUser (signUpRequest) {
  if (signUpRequest.type === 'EMAIL') {
    try {
      await auth.createUserWithEmailAndPassword(signUpRequest.email, signUpRequest.password)
      console.groupCollapsed('%c User ', CONSOLE_TAG_GREEN, 'New user auth created')
      console.groupEnd()
      return {
        success: true,
        error: ''
      }
    } catch (error) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'New user auth not created')
      console.log(error)
      console.groupEnd()
      return {
        success: false,
        error: parseAuthErrorCode(error.code)
      }
    }
  } else {
    return {
      success: false,
      error: 'Unknown authentication method'
    }
  }
}

function onlineInit () {
  console.log('%c App : Online Initialization ', CONSOLE_TAG_BLUE, 'Online initialization start')
  if (authStateListener !== null) {
    console.log('%c App : Online Initialization ', CONSOLE_TAG_GREEN, 'Online initialization already finished')
    return {
      success: true,
      error: ''
    }
  }
  console.log('%c User ', CONSOLE_TAG_BLUE, 'Start listening to auth state changes.')
  authStateListener = auth.onAuthStateChanged(user => {
    // console.log('auth change detected')
    sendEvent('LOCAL_DB', 'authStateChange', user)
  })
  console.log('%c App : Online Initialization', CONSOLE_TAG_GREEN, 'Online initialization success')
  return {
    success: true,
    error: ''
  }
}

async function authSignIn (signInRequest) {
  if (signInRequest.type === 'EMAIL') {
    // verify if request meet requirements
    if (!is.email(signInRequest.email)) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Invalid Email')
      console.log(signInRequest.email)
      console.groupEnd()
      return {
        success: false,
        error: 'Invalid Email Address'
      }
    }
    if (signInRequest.password.length < 6) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Password Too Weak')
      console.log()
      console.groupEnd()
      return {
        success: false,
        error: 'Password Too Weak'
      }
    }
    // human test
    if (!await verifyReCaptcha(signInRequest.token)) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'reCAPTCHA Not Pass')
      console.log(signInRequest.token)
      console.groupEnd()
      return {
        success: false,
        error: 'Unable to pass human check'
      }
    }
    // auth sign in
    try {
      await auth.signInWithEmailAndPassword(signInRequest.email, signInRequest.password)
      console.groupCollapsed('%c User ', CONSOLE_TAG_GREEN, 'Auth Sign In Success')
      console.log(signInRequest.email)
      console.groupEnd()
      return {
        success: true,
        error: ''
      }
    } catch (error) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Auth Sign In Failed')
      console.log(signInRequest.email, error)
      console.groupEnd()
      return {
        success: false,
        error: parseAuthErrorCode(error.code)
      }
    }
  } else {
    console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Unknown Auth Sign Method')
    console.log(signInRequest.type, 'AUTH SIGN IN NOT CALLED')
    console.groupEnd()
    return {
      success: false,
      error: `Unknown Sign Method => ${signInRequest.type}`
    }
  }
}

async function authSignOut () {
  if (authStateListener === null) {
    console.log('%c User ', CONSOLE_TAG_ORANGE, 'No auth listener in use')
    sendEvent('LOCAL_DB', 'authStateChange', null)
    return
  }
  auth.signOut()
  console.log('%c User ', CONSOLE_TAG_BLUE, 'Stop listening to auth state changes.')
  authStateListener = null // user signed out, clear authStateListener
  console.log('%c User ', CONSOLE_TAG_ORANGE, 'Authentication state has been cleared, this may due to user signed out or token expired.')
  sendEvent('LOCAL_DB', 'authStateChange', null)
}

async function resetPassword (email) {
  if (is.email(email)) {
    try {
      await auth.sendPasswordResetEmail(email)
      console.groupCollapsed('%c User ', CONSOLE_TAG_GREEN, 'Password reset email sent')
      console.log(email)
      console.groupEnd()
      return {
        success: true,
        error: false,
        message: 'Password reset email sent.'
      }
    } catch (error) {
      console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Password reset email send failed')
      console.log(error)
      console.groupEnd()
      return {
        success: false,
        error: parseAuthErrorCode(error.code)
      }
    }
  } else {
    console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Password reset email no send')
    console.log('Invalid email address', email)
    console.groupEnd()
    return {
      success: false,
      error: 'Please input a valid email address'
    }
  }
}

async function recordSignIn (uid, email) {
  let normalUserRef = USER_LIST_REF.doc(uid)
  let tempUserRef = USER_LIST_REF.doc(window.btoa(email).replace(/\//g, ''))
  let deviceSnapshot = {
    androidPhone: is.androidPhone(),
    androidTablet: is.androidTablet(),
    desktop: is.desktop(),
    ipad: is.ipad(),
    iphone: is.iphone(),
    windows: is.windows(),
    mac: is.mac()
  }
  return db.runTransaction(t => {
    return t.get(normalUserRef).then(doc => {
      if (doc.exists) {
        let stamp = Date.now()
        let signInSnapShot = {
          op: 'SIGN_IN',
          deviceSnapshot: deviceSnapshot,
          stamp: stamp,
          id: normalUserRef.collection('history').doc().id
        }
        t.update(normalUserRef, { lastSignInOn: stamp })
        t.set(normalUserRef.collection('history').doc(signInSnapShot.id), signInSnapShot)
        return uid
      } else {
        console.log(`Create from temp user, ${email}(${tempUserRef.id})`)
        return tempUserRef.get().then(doc => {
          if (!doc.exists) {
            console.groupCollapsed('%c User ', CONSOLE_TAG_GREEN, 'Record Sign In Failed (Transaction)')
            console.log('Temp User not exists')
            console.groupEnd()
            throw new Error('No temp user found')
          }
          let stamp = Date.now()
          let currentUser = doc.data()
          let newUser = {
            uid: uid,
            name: currentUser.name,
            status: 'ACTIVE',
            email: currentUser.email,
            userScope: currentUser.userScope,
            signUpOn: stamp,
            lastSignInOn: stamp
          }
          let signUpSnapShot = {
            op: 'SIGN_UP',
            deviceSnapshot: deviceSnapshot,
            stamp: stamp,
            id: USER_LIST_REF.doc(uid).collection('history').doc().id
          }
          t.set(USER_LIST_REF.doc(uid), newUser)
          t.set(USER_LIST_REF.doc(uid).collection('history').doc(signUpSnapShot.id), signUpSnapShot)
          t.delete(tempUserRef)
          return uid
        })
      }
    })
  }).then(uid => {
    console.groupCollapsed('%c User ', CONSOLE_TAG_GREEN, 'Sign in successfully recorded')
    console.log(`uid => *****************${uid.slice(-4)}`)
    console.groupEnd()
    return {
      success: true,
      error: '',
      errorDetail: null
    }
  }).catch(err => {
    console.groupCollapsed('%c User ', CONSOLE_TAG_RED, 'Sign in Record Filed (Transaction)')
    console.log(err)
    console.groupEnd()
    return {
      success: false,
      error: 'Transaction failed [You can find error detail by print errorDetail prop]',
      errorDetail: err
    }
  })
}

async function listenToUser (uid) {
  states.currentUser = USER_LIST_REF.doc(uid).onSnapshot(async (doc) => {
    if (!doc.exists) {
      // console.log('Waiting for user data be ready')
      console.groupCollapsed('%c User ', CONSOLE_TAG_ORANGE, 'Waiting for user data')
      console.log(`uid => *****************${uid.slice(-4)}`)
      console.groupEnd()
      return
    }
    let currentUser = doc.data()
    console.groupCollapsed('%c User ', CONSOLE_TAG_BLUE, 'User states change detected')
    console.log(`uid => *****************${uid.slice(-4)}`, currentUser.status)
    console.groupEnd()
    if (currentUser.status === 'HOLD') {
      sendEvent('VUEX', 'signInError', 'Your account is suspended by admin')
      sendEvent('LOCAL_DB', 'currentUser', null)
    } else if (currentUser.status === 'ACTIVE') {
      sendEvent('LOCAL_DB', 'currentUser', currentUser)
    }
  })
}

async function connect () {
  linkProjects()
  await pauser(3000)
  linkFormQuestions()
  await pauser(3000)
  linkFormTemplates()
  await pauser(3000)
  linkUsers()
}

async function switchProjectOnline (projectId) {
  if (typeof projectId !== 'string') {
    return {
      success: false,
      error: 'Invalid project id'
    }
  }
  try {
    await PROJECT_LIST_REF.doc(projectId).update({ lastOpenOn: Date.now() })

    listeners.currentProject()
    listeners.currentProject = PROJECT_LIST_REF.doc(projectId).onSnapshot(doc => {
      if (!doc.exists) {
        console.warn('project record not found')
        sendEvent('LOCAL_DB', 'updateCurrentProject', null)
      }
      sendEvent('LOCAL_DB', 'updateCurrentProject', doc.data())
    })

    listeners.currentFolders()
    listeners.currentFolders = FOLDER_LIST_REF.where('projectId', '==', projectId).orderBy('name').onSnapshot(querySnapshot => {
      let folders = []
      if (querySnapshot.size !== 0) {
        querySnapshot.forEach(doc => {
          folders.push(doc.data())
        })
      }
      sendEvent('LOCAL_DB', 'updateCurrentFolders', folders)
    })

    listeners.currentItems()
    listeners.currentItems = ITEM_LIST_REF.where('projectId', '==', projectId).onSnapshot(querySnapshot => {
      let items = []
      if (querySnapshot.size !== 0) {
        querySnapshot.forEach(doc => {
          items.push(doc.data())
        })
      }
      sendEvent('LOCAL_DB', 'updateCurrentItems', items)
    })
    return {
      success: true,
      error: ''
    }
  } catch (err) {
    console.warn('Switch project online failed')
    return {
      success: false,
      error: err
    }
  }
}

async function addProject (projectInfo) {
  let projectRef = PROJECT_LIST_REF.doc(projectInfo.id)
  try {
    await db.runTransaction(t => {
      return t.get(projectRef).then(doc => {
        if (doc.exists) {
          Promise.reject(new Error('Project ID already exist, try another name'))
        }
        t.set(projectRef, projectInfo)
      })
    })
    return {
      success: true,
      error: ''
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: typeof error === 'string' ? error : 'Unable to add project, please try later.'
    }
  }
}

function getRandomId (collection) {
  switch (collection) {
    case 'folders':
      return FOLDER_LIST_REF.doc().id
    case 'items':
      return ITEM_LIST_REF.doc().id
  }
}

async function setFolderOnline (folder) {
  if (typeof folder !== 'object') {
    return {
      success: false,
      error: 'Missing folder info'
    }
  }
  // upload all pending base64 image
  folder.images = await Promise.all(folder.images.map(
    async (image) => {
      if (image.indexOf('https://') === 0) {
        return image
      } else if (image.indexOf('data:image') === 0) {
        let uploadResult = await uploadImageOnline(image)
        if (uploadResult.success) {
          return uploadResult.url
        } else {
          return image
        }
      } else {
        console.warn('Unknown image url or data =>', image)
        return image
      }
    }
  ))
  let folderRef = FOLDER_LIST_REF.doc(folder.id)
  try {
    await folderRef.set(folder)
    sendEvent('LOCAL_DB', 'clearOfflineFolder', folder.id)
    return {
      success: true,
      error: '',
      folder: folder
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: error
    }
  }
}

// async function uploadOfflineFolders(folders) {
//   if (!(folders.length > 0)) {
//     // console.warn('No offline folder will be uploaded')
//     return null
//   }
//   let batch = db.batch()
//   for (let folder of folders) {
//     let folderRef = FOLDER_LIST_REF.doc(folder.id)
//     batch.set(folderRef, folder)
//   }
//   return await batch.commit()
// }

async function setItemOnline (itemData) {
  if (typeof itemData !== 'object') {
    return {
      success: false,
      error: 'Item data must be provided'
    }
  }
  // upload all pending base64 image
  itemData.images = await Promise.all(itemData.images.map(
    async (image) => {
      if (image.indexOf('https://') === 0) {
        return image
      } else if (image.indexOf('data:image') === 0) {
        let uploadResult = await uploadImageOnline(image)
        if (uploadResult.success) {
          return uploadResult.url
        } else {
          return image
        }
      } else {
        console.warn('Unknown image url or data =>', image)
        return image
      }
    }
  ))
  let itemRef = ITEM_LIST_REF.doc(itemData.id)
  try {
    await db.runTransaction(t => {
      return t.get(itemRef).then(doc => {
        let history = {}
        if (doc.exists && itemData.open) {
          itemData.version = doc.data().version + 1
          history = getItemHistory(itemData, 'EDIT')
        } else if (doc.exists) {
          history = getItemHistory(itemData, 'DELETE')
        } else {
          history = getItemHistory(itemData, 'CREATE')
        }
        let historyRef = ITEM_LIST_REF.doc(itemData.id).collection('historyVersion').doc(history.id)

        t.set(itemRef, itemData)
        t.set(historyRef, history)
      })
    })
    return {
      success: true,
      error: '',
      item: itemData
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: error
    }
  }
}

async function uploadImageOnline (file) {
  if (!file) {
    return {
      success: false,
      error: 'Invalid data format(must be a base64 string)'
    }
  }
  let contentType = (file.split(';')[0]).split(':')[1]
  // console.log(contentType)
  if (!['image/jpeg', 'image/png'].includes(contentType)) {
    return {
      success: false,
      error: 'Only JPEG and PNG are support.'
    }
  }
  let ext = contentType === 'image/jpeg' ? '.jpg' : '.png'
  let dataBody = file.split(',')[1]
  let randomId = Date.now() + String(Math.random()).slice(4)
  let fileName = randomId + ext
  let fileMeta = {
    contentType: contentType
  }
  let imageRef = storage.ref().child(`user_images/${fileName}`)
  try {
    await imageRef.putString(dataBody, 'base64', fileMeta)
    let url = await imageRef.getDownloadURL()
    return {
      success: true,
      url: url
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: 'Unable to upload image, network unstable'
    }
  }
}

async function sendInvitationEmail (email) {
  if (!is.email(email)) {
    return {
      success: false,
      error: 'Invalid email address'
    }
  }
  const sendAPI = functions.httpsCallable('sendInvitationEmail')
  try {
    let sendResult = await sendAPI({ emailAddress: email })
    return sendResult.data
  } catch (err) {
    console.warn(err)
    return {
      success: false,
      error: 'Cannot send the invitation email, please try again'
    }
  }
}

async function changeUserStatus (userStatusChangeRequest) {
  if (!userStatusChangeRequest.uid) {
    return {
      success: false,
      error: 'Invalid user uid'
    }
  }
  if (userStatusChangeRequest.newStatus !== 'HOLD' && userStatusChangeRequest.newStatus !== 'ACTIVE') {
    return {
      success: false,
      error: 'Invalid user status'
    }
  }

  let userRef = USER_LIST_REF.doc(userStatusChangeRequest.uid)
  let opHistoryRef = userRef.collection('history').doc()
  let opHistory = {
    operator: userStatusChangeRequest.operator,
    op: userStatusChangeRequest.newStatus,
    id: opHistoryRef.id,
    stamp: Date.now()
  }
  try {
    await db.runTransaction(t => {
      return t.get(userRef).then(doc => {
        if (!doc.exists) {
          Promise.reject(new Error('User not found'))
        }
        t.update(userRef, { status: opHistory.op })
        t.set(opHistoryRef, opHistory)
      })
    })
    return {
      success: true,
      error: ''
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: typeof error === 'string' ? error : 'Unable to finish request, please try again later'
    }
  }
}

async function changeUserScope (userScopeChangeRequest) {
  if (!userScopeChangeRequest.uid) {
    return {
      success: false,
      error: 'Invalid user uid'
    }
  }
  if (userScopeChangeRequest.newScope > 4 || userScopeChangeRequest.newScope < 2) {
    return {
      success: false,
      error: 'Invalid user role'
    }
  }

  let userRef = USER_LIST_REF.doc(userScopeChangeRequest.uid)
  let opHistoryRef = userRef.collection('history').doc()
  let opHistory = {
    operator: userScopeChangeRequest.operator,
    op: 'SCOPE_CHANGE',
    newScope: userScopeChangeRequest.newScope,
    id: opHistoryRef.id,
    stamp: Date.now()
  }
  try {
    await db.runTransaction(t => {
      return t.get(userRef).then(doc => {
        if (!doc.exists) {
          Promise.reject(new Error('User not found'))
        }
        t.update(userRef, { userScope: opHistory.newScope })
        t.set(opHistoryRef, opHistory)
      })
    })
    return {
      success: true,
      error: ''
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: typeof error === 'string' ? error : 'Unable to finish request, please try again later'
    }
  }
}

async function changeProjectSetting (project) {
  try {
    let projectRef = PROJECT_LIST_REF.doc(project.id)
    await projectRef.set(project)
    console.groupCollapsed('%c Data : Projects ', CONSOLE_TAG_GREEN, 'Project setting saved')
    console.log(project)
    console.groupEnd()
    return {
      success: true,
      error: ''
    }
  } catch (error) {
    console.groupCollapsed('%c Data : Projects ', CONSOLE_TAG_RED, 'Unable save project setting =>')
    console.log(error)
    console.groupEnd()
    return {
      success: false,
      error: 'Cannot save change, please try again later'
    }
  }
}

async function uploadExportedFile (blob, fileName) {
  if (!navigator.onLine) {
    return {
      success: false,
      error: 'No network connection'
    }
  }
  let fileRef = storage.ref().child(`exported_files/${fileName}`)
  let fileMeta = {
    contentType: 'pdf'
  }
  try {
    await fileRef.put(blob, fileMeta)
    let url = await fileRef.getDownloadURL()
    console.log(url)
    return {
      success: true,
      url: url
    }
  } catch (error) {
    console.warn(error)
    return {
      success: false,
      error: 'Unable to upload file, network unstable'
    }
  }
}

/// ///////////////////////////////////////////////////////////////////////////////////////
/*
,--.  ,--.,------.,--.   ,------. ,------.,------.
|  '--'  ||  .---'|  |   |  .--. '|  .---'|  .--. '
|  .--.  ||  `--, |  |   |  '--' ||  `--, |  '--'.'
|  |  |  ||  `---.|  '--.|  | --' |  `---.|  |\  \
`--'  `--'`------'`-----'`--'     `------'`--' '--'

,------.,--. ,--.,--.  ,--. ,-----.,--------.,--. ,-----. ,--.  ,--.
|  .---'|  | |  ||  ,'.|  |'  .--./'--.  .--'|  |'  .-.  '|  ,'.|  |
|  `--, |  | |  ||  |' '  ||  |       |  |   |  ||  | |  ||  |' '  |
|  |`   '  '-'  '|  | `   |'  '--'\   |  |   |  |'  '-'  '|  | `   |
`--'     `-----' `--'  `--' `-----'   `--'   `--' `-----' `--'  `--'

*/
// The function send the event to vuex or localDB
function sendEvent (target, eventName, data) {
  if (typeof eventName !== 'string') {
    console.warn('event name must be a string, is =>', eventName)
    return
  }
  let payload = {
    event: eventName,
    data: data
  }
  let event = null
  if (target === 'VUEX') {
    // console.log('Send event to VUEX')
    event = new CustomEvent('FIRE-SERVICE-EVENT-TO-VUEX', { detail: payload })
  } else if (target === 'LOCAL_DB') {
    // console.log('Send event to LOCAL DB')
    event = new CustomEvent('FIRE-SERVICE-EVENT-TO-LOCAL-DB', { detail: payload })
  } else {
    console.warn('Unknown event target =>', target)
  }
  if (event !== null) {
    document.dispatchEvent(event)
  }
}

function parseAuthErrorCode (error) {
  switch (error) {
    case 'auth/user-disabled':
      return 'This account has been disabled'
    case 'auth/invalid-email':
      return 'Invalid email address'
    case 'auth/user-not-found':
      return 'No user found for this email address'
    case 'auth/wrong-password':
      return 'Incorrect email address or password'
    case 'auth/email-already-in-use':
      return 'Email address already exists'
    case 'auth/weak-password':
      return 'Password too weak'
    default:
      return 'Unable to contact authentication server'
  }
}

function linkProjects () {
  listeners.projects = PROJECT_LIST_REF.orderBy('createOn', 'desc').onSnapshot(async (querySnapshot) => {
    console.log('Firebase_Update projects')
    let projectList = []
    querySnapshot.forEach(doc => {
      projectList.push(doc.data())
    })
    console.groupCollapsed('%c Data : Projects ', CONSOLE_TAG_BLUE, `Updating ${projectList.length} projects`, projectList)
    sendEvent('LOCAL_DB', 'updateProjects', projectList)
  })
}

function linkFormTemplates () {
  listeners.formTemplates = FORM_TEMPLATE_LIST_REF.orderBy('templateName').onSnapshot(async (querySnapshot) => {
    console.log('Firebase_Update form templates')
    let templateList = []
    querySnapshot.forEach(doc => {
      templateList.push(doc.data())
    })
    console.groupCollapsed('%c Data : Templates ', CONSOLE_TAG_BLUE, `Updating ${templateList.length} templates`, templateList)
    sendEvent('LOCAL_DB', 'updateFormTemplates', templateList)
  })
}

function linkFormQuestions () {
  listeners.formQuestions = FORM_QUESTION_LIST_REF.onSnapshot(async (querySnapshot) => {
    console.log('Firebase_Update form questions')
    let questionList = []
    querySnapshot.forEach(doc => {
      questionList.push(doc.data())
    })
    console.groupCollapsed('%c Data : Questions ', CONSOLE_TAG_BLUE, `Updating ${questionList.length} questions`, questionList)
    sendEvent('LOCAL_DB', 'updateFormQuestions', questionList)
  })
}

function linkUsers () {
  listeners.users = USER_LIST_REF.onSnapshot(async (querySnapshot) => {
    console.log('Firebase_Update user list')
    let userList = []
    querySnapshot.forEach(doc => {
      userList.push(doc.data())
    })
    console.groupCollapsed('%c Data : Users ', CONSOLE_TAG_BLUE, `Updating ${userList.length} users`, userList)
    sendEvent('LOCAL_DB', 'updateUsers', userList)
  })
}

function getItemHistory (itemData, op) {
  if (op === 'EDIT') {
    let historyRef = ITEM_LIST_REF.doc(itemData.id).collection('historyVersion').doc()
    let history = {
      id: historyRef.id,
      op: 'EDIT',
      itemSnapshot: itemData,
      stamp: itemData.lastEditOn,
      user: itemData.lastEditBy,
      version: itemData.version
    }
    return history
  } else if (op === 'CREATE') {
    let historyRef = ITEM_LIST_REF.doc(itemData.id).collection('historyVersion').doc()
    let history = {
      id: historyRef.id,
      op: 'INIT_CREATE',
      itemSnapshot: itemData,
      stamp: itemData.createOn,
      user: itemData.createBy,
      version: 0
    }
    return history
  } else if (op === 'DELETE') {
    let historyRef = ITEM_LIST_REF.doc(itemData.id).collection('historyVersion').doc()
    let history = {
      id: historyRef.id,
      op: 'DELETE',
      itemSnapshot: itemData,
      stamp: itemData.lastEditOn,
      user: itemData.lastEditBy,
      version: itemData.version
    }
    return history
  } else {
    throw new Error('Invalid operation while preparing history')
  }
}

async function pauser (time) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(null)
    }, time)
  })
}
